import { css, cx } from '@linaria/core';
import { baseTheme, breakpoints, flex } from 'styles/utils';
export const tagWrapper = cx("omponents__EntityCard__TagList_styles_ts-tagWrapper-t17r344w", flex.init, flex.direction.row, flex.gap.half);
export const tagItem = "omponents__EntityCard__TagList_styles_ts-tagItem-t8k1dcc";
export const themeBlue = "omponents__EntityCard__TagList_styles_ts-themeBlue-t1wai35y";

require("./TagList.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TagList.styles.ts");